import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { StoreModule } from '@ngrx/store';
import { DialogModule } from '@syncfusion/ej2-angular-popups';

import { RalErrorDialogComponent } from './error-dialog.component';
import {
  ERROR_DIALOG_FEATURE_KEY,
  errorDialogReducer,
} from './error-dialog.reducer';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    DialogModule,
    StoreModule.forFeature(ERROR_DIALOG_FEATURE_KEY, errorDialogReducer),
  ],
  exports: [RalErrorDialogComponent],
  declarations: [RalErrorDialogComponent],
})
export class ErrorDialogModule {}
